import * as React from 'react';
import api from '../api/apiClient';
import moment from 'moment';

import ResultsTable from '../Components/ResultsTable';
import CompetitorDetails from '../Components/CompetitorDetails';
import ClassSelector from '../Components/ClassSelector';
import Duration from '../utils/duration';
import { applyFinishState, resolveFinishGate, getRaceClock } from '../utils/finish';

import { connectRaceHub } from '../services/raceHub';

import Security from '../services/authService';
import { Link } from "react-router-dom";
import { withRouter } from '../hoc/withRouter';


interface RaceResultsCmponentState {

	race: any,
	checkpoints: Array<any>,
	results: Array<any>,
	competitors: { [key: string]: any }, // Updated type to match object usage
	seriesClassId: string,

	showDetails: any,
	now: Date,
	loading: boolean // Added loading state
};

class RaceResultsPage extends React.Component<any, RaceResultsCmponentState> {


	constructor(props) {
		super(props);

		this.setClass = this.setClass.bind(this);
	}

	private interval: any;
	private disconnectHub: (() => void) | null = null;

	componentDidMount() {
		Security.isAdmin()
		var raceid = this.props.match.params.raceid;

		this.setState({ loading: true }); // Set loading to true initially

		var racePromise = api.request('races/' + raceid)
			.then(data => {
				if (!data) {
					console.error('API returned undefined for race data');
					throw new Error('Race data is undefined');
				}
				this.setState({ race: data });

				if (!data.finished) {
					this.setupHub();
				}
				return data; // Ensure the resolved value is returned
			})
			.catch(error => {
				console.error('Error fetching race data:', error);
				return undefined; // Ensure Promise.all continues even if this fails
			});

		var competitorsPromise = api.request('competitors/inrace?raceid=' + raceid).then(data => {
			const competitorsMap = data.reduce((map, obj) => (map[obj.id] = obj, map), {});
			this.setState({ competitors: competitorsMap });
			return competitorsMap;
		});

		var checkpointPromise = this.getCheckpointData();


		Promise.all([racePromise, checkpointPromise, competitorsPromise]).then(([raceData, checkpointData, competitorsData]: [any, any[], { [key: string]: any }]) => {
			// Ensure race data is fully loaded before calling calculateReults
			if (raceData && raceData.start) {
				const competitors = competitorsData || this.state.competitors;
				const racestart = moment(raceData.start);
				const gate = resolveFinishGate(checkpointData, competitors, raceData, racestart);

				this.setState({
					gate: gate,
					results: this.calculateReults(checkpointData, competitors, racestart, raceData, gate),
					loading: false // Set loading to false after data is ready
				});
			} else {
				console.error('Race data is missing or incomplete:', raceData);
				this.setState({ loading: false });
			}
		});

		this.interval = setInterval(() => this.tick(), 1000);
	}

	setupHub = () => {
		this.disconnectHub = connectRaceHub({
			raceId: this.props.match.params.raceid,

			onCheckpointAdded: (checkpoint, competitor) => {
				// Checkpoints can arrive in the same tick at a busy finish line, so
				// state has to be derived from the previous state, not read off
				// this.state.
				this.setState(prev => {
					// The transponder may not be matched to anyone in this race.
					const competitors = (competitor && competitor.id && !prev.competitors[competitor.id])
						? { ...prev.competitors, [competitor.id]: competitor }
						: prev.competitors;

					return { competitors: competitors, checkpoints: [...prev.checkpoints, checkpoint] };
				}, this.updateResult);
			},

			onResync: this.checkpointDataChanged
		});
	}

	getCheckpointData = () => {
		return api.request('checkpoints/?raceid=' + this.props.match.params.raceid).then(data => {
			// The api client swallows failures and resolves undefined. Resync runs on
			// every foreground, so a dropped request on a phone must not tear down
			// the checkpoints we already have.
			if (!data) return this.state.checkpoints;

			data.sort((a, b) => this.stringOrder(a.timestamp, b.timestamp));
			this.setState({ checkpoints: data });
			return data; // Return data for Promise.all
		});
	}

	componentWillUnmount() {
		clearInterval(this.interval);

		if (this.disconnectHub) {
			this.disconnectHub();
			this.disconnectHub = null;
		}
	}

	private tick = () => {
		this.setState({ now: new Date() });
	}

	state = {
		race: {
			name: null,
			eventId: null,
			start: null,
			seriesId: null,
			finished: true,
			duration: 0,
			laps: 0,
			finishMode: 0
		},
		gate: null,
		checkpoints: [],
		results: [],
		competitors: {},

		tableClass: 'showLapTime',
		seriesClassId: null,
		showDetails: null,
		now: new Date(),
		loading: false // Initialize loading state
	};

	stringOrder = (a: string, b: string) => (a < b) ? -1 : (a > b) ? 1 : 0;

	calculateReults = (checkpoints, competitors, racestart, race, gate) => {
		// Safety check: ensure competitors is not null/undefined
		if (!competitors || !checkpoints) {
			return [];
		}

		var timer = performance.now();

		var competitorsCheckpoints = [];
		//var competitors = {};

		var laps = [];

		var fastestLap = null

		for (var checkpoint of checkpoints) {


			var competitorId = checkpoint.competitorId;
			/*
			 	
				 if (competitors[competitorId] === undefined) {
		 competitors[competitorId] = { id: competitorId, name: 'Huh?' };//checkpoint.competitor;					
				 }
			  */

			var competitor = competitors[competitorId];

			if (competitor) {
				if (competitorsCheckpoints[competitorId] === undefined) {
					competitorsCheckpoints[competitorId] = [];
				}

				var competitorCheckpoints = competitorsCheckpoints[competitorId];


				var lastLap = null;

				var lapnr = competitorCheckpoints.length - 1;
				while (lapnr >= 0 && lastLap == null) {
					if (!competitorCheckpoints[lapnr].deleted) {
						lastLap = competitorCheckpoints[lapnr];
					}

					lapnr--;
				}

				//var lapNumber = competitorCheckpoints.length;

				var lapNumber = (lastLap == null) ? 0 : lastLap.lapNumber;

				if (!laps[lapNumber]) {
					laps[lapNumber] = [];
				}

				var lapCheckpoints = laps[lapNumber];

				var nextCompetitor = lapCheckpoints.length > 0 ? lapCheckpoints[lapCheckpoints.length - 1] : null;
				var firstCompetitor = lapCheckpoints.length > 0 ? lapCheckpoints[0] : null;

				var timestamp = moment(checkpoint.timestamp);

				timestamp.diff(racestart);

				checkpoint.timestamp = timestamp;
				checkpoint.totaltime = timestamp.diff(racestart);


				var lastLapTimestamp = lastLap == null ? racestart : lastLap.timestamp;

				checkpoint.laptime = timestamp.diff(lastLapTimestamp);
				checkpoint.behindFirst = firstCompetitor == null ? null : timestamp.diff(firstCompetitor.timestamp);
				checkpoint.behindNext = nextCompetitor == null ? null : timestamp.diff(nextCompetitor.timestamp);
				checkpoint.pos = laps[lapNumber].length + 1;
				checkpoint.posDiff = (lastLap == null ? null : lastLap.pos - checkpoint.pos);
				checkpoint.laptimeDiffFromFirst = firstCompetitor ? checkpoint.laptime - firstCompetitor.laptime : null;
				checkpoint.laptimeDiffFromNext = nextCompetitor ? checkpoint.laptime - nextCompetitor.laptime : null;
				checkpoint.laptimeDiff = (lastLap == null ? null : checkpoint.laptime - lastLap.laptime);
				checkpoint.lapNumber = (lastLap == null ? 1 : lastLap.lapNumber + 1);

				if (!checkpoint.deleted) {

					if (checkpoint.lapNumber != 1) {
						if (competitor.fastestLap == null || competitor.fastestLap.laptime > checkpoint.laptime) {
							if (competitor.fastestLap != null) competitor.fastestLap.bestLap = false;
							checkpoint.bestLap = true;
							competitor.fastestLap = checkpoint;
						}


						if (fastestLap == null || fastestLap.laptime > checkpoint.laptime) {
							if (fastestLap != null) fastestLap.fastestLap = false;
							checkpoint.fastestLap = true;
							fastestLap = checkpoint;
						}
					}

					laps[lapNumber].push(checkpoint);
				}


				competitorCheckpoints.push(checkpoint);

			}
		}

		var results = [];


		for (var id in competitorsCheckpoints) {
			results.push({ competitor: competitors[id], checkpoints: competitorsCheckpoints[id] });
		}

		applyFinishState(results, race, racestart, gate);

		results.sort((a, b) => {
			var ac = a.checkpoints.filter(c => !c.deleted);
			var bc = b.checkpoints.filter(c => !c.deleted);
			return (ac.length == bc.length) ?
				this.stringOrder(ac[ac.length - 1].timestamp, bc[bc.length - 1].timestamp)
				: bc.length - ac.length
		}
		)

		results.map((result, index) => result.position = index + 1);

		console.log('Calculation took: ' + (performance.now() - timer) + ' ms');


		return results;
	}

	updateResult = () => {
		const race = this.state.race;
		const racestart = moment(race.start);

		// The gate is a property of the race, not of the class being viewed, so it is
		// always resolved against the full checkpoint list.
		const gate = resolveFinishGate(this.state.checkpoints, this.state.competitors, race, racestart);

		const checkpoints = this.state.seriesClassId
			? this.state.checkpoints.filter(x => this.state.competitors[x.competitorId] && this.state.competitors[x.competitorId].seriesClassId == this.state.seriesClassId)
			: this.state.checkpoints;

		this.setState({
			gate: gate,
			results: this.calculateReults(checkpoints, this.state.competitors, racestart, race, gate)
		});
	};

	setClass = (seriesClassId) => {
		this.setState({ seriesClassId: seriesClassId }, () => {
			this.updateResult();
		});
	};

	competitorClicked = (competitor) => {
		this.setState({ showDetails: competitor })
	}

	checkpointDataChanged = () => {
		this.getCheckpointData().then(() => {
			this.updateResult();
		});
	}

	renderRaceClock = () => {
		const clock = getRaceClock(this.state.race, moment(this.state.race.start), moment(), this.state.gate);

		if (clock.flagOut) {
			return <h3 className="mb-0 text-danger"><i className="fas fa-flag-checkered me-2"></i>Flag out</h3>;
		}

		if (!clock.hasClock) {
			// Laps-only race - show the leader's progress towards the distance instead.
			if (!clock.totalLaps) return null;
			const leaderLaps = this.state.results.length ? this.state.results[0].checkpoints.filter(c => !c.deleted).length : 0;
			return <h3 className="mb-0 text-muted">Lap {Math.min(leaderLaps, clock.totalLaps)} / {clock.totalLaps}</h3>;
		}

		if (clock.expired) {
			// Clock is done; the leader is running out the extra laps, or riders are
			// coming round to the flag.
			return <h3 className="mb-0 text-warning">{clock.extraLaps ? '+' + clock.extraLaps + (clock.extraLaps == 1 ? ' lap' : ' laps') : 'Finishing'}</h3>;
		}

		return (
			<h3 className="mb-0 text-muted">
				-{Duration(clock.remaining).format()}
				{clock.extraLaps > 0 && <small className="ms-2">+{clock.extraLaps} {clock.extraLaps == 1 ? 'lap' : 'laps'}</small>}
			</h3>
		);
	}

	render() {
		if (this.state.loading) {
			return <div>Loading...</div>; // Display loading message while data is being fetched
		}

		if (this.state.showDetails) {
			return (
				<div>
					<CompetitorDetails results={this.state.results.filter(x => x.competitor.id == this.state.showDetails.id)} showETA={!this.state.race.finished} checkpointDataChanged={() => this.checkpointDataChanged()} race={this.state.race} />
					<button onClick={() => this.competitorClicked(null)} className="btn btn-success">Close</button>
				</div>
			);
		}
		else {
			return (
				<div>
					<h2>{this.state.race.name}</h2>

					{!this.state.race.finished &&
						<div className="d-flex align-items-baseline flex-wrap gap-3">
							<h3 className="mb-0">{Duration(moment.duration(moment().diff(moment(this.state.race.start))).asMilliseconds()).format()}</h3>
							{this.renderRaceClock()}
						</div>
					}
					<ClassSelector seriesId={this.state.race.seriesId} onChange={this.setClass} showAllButton={true}></ClassSelector>
					<div className="mt-2">
						<ResultsTable results={this.state.results} competitors={this.state.competitors} onCompetitorClick={this.competitorClicked} showETA={!this.state.race.finished} />
					</div>
					<div>
						<Link to={'/event/' + this.state.race.eventId} className="btn btn-success">Back</Link>
					</div>
				</div>
			);
		}
	}
}

export default withRouter(RaceResultsPage);
